import React from 'react';
import styles from './Modal.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../axios/Axios.js';
import "./Modal.css"
import { getToken } from "../../../services/auth";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";
import axios from 'axios';
import { useSnackbar } from 'notistack';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function Modal({handleReload, logoUpload, setLogoUpload, formData, setFormData , isOpen, onClose}) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [uploadedFiles, setUploadedFiles] = useState([])

  const reset = () => {
              uploadedFiles.forEach(f => f.remove())
  }

  const MODAL_URL = "/clients";
  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  };

  const cleanData = async () => {
    setFormData({
      name: '',
      key: '',
      escope: '',
      start: dayjs()
    })
    setLogoUpload(null)

    reset();

  };

  
  const handleChangeStatus = ({meta, file, xhr, ...rest}, status) => {
    if (status !== "removed") {
      setLogoUpload(file);
    } else {
      setLogoUpload(null);
    }

    const fileRemove = rest.remove;

    setUploadedFiles(fids => [...fids, {
      name: file.name,
      remove: fileRemove
    }]);
  }
  
  const handleSubmit = async () => {
    setLoading(true);

    await axiosBackend.post(MODAL_URL, { ...formData, start: formData.start.unix() }, config).then((response) => {
      const uuidGenerated = response.data.uuid;

      const exten = "."+logoUpload?.type.split("/").pop()
      
      config["params"] = {
        ext: exten,
        uuid: uuidGenerated
      }
  
      axiosBackend.get("logo", config).then( (response2) => {
        const fileForm = new FormData();
  
        Object.entries(response2.data.fields).forEach(([key, value]) => {
          fileForm.append(key, value);
        });
    
        fileForm.append("file", logoUpload);
    
        axios.post(response2.data.url, fileForm, {
          headers: {
            'Content-Type': 'multipart/form-data'
            }              
            }).then(function (response) {
            })
              .catch(function (error) {
            }).catch((err) => {

            if (err.data?.message) {
              enqueueSnackbar(err.data.message, { 
                variant: 'error'
              });
            } else {
              enqueueSnackbar('Falha ao fazer upload da imagem.', { 
                variant: 'error'
              });
            };
            });
            axiosBackend.post("logo", {}, config).then((result) => {
              enqueueSnackbar('Cliente inserido com sucesso.', { 
                variant: 'success'
          });
            handleReload();
            cleanData();
            onClose();
            setLoading(false);
          }).catch( (response_final) => {
            enqueueSnackbar('Falha ao fazer upload da imagem.', { 
              variant: 'error'
            })
            onClose();
            setLoading(false);
          })
      }).catch( (err) => {
        if (err.data?.message) {
          enqueueSnackbar(err.data.message, { 
            variant: 'error'
          });
        } else {
          enqueueSnackbar('Falha ao fazer upload da imagem.', { 
            variant: 'error'
          });
        };
        onClose();
        setLoading(false);
      });
  
      
    }).catch((err) => {
    enqueueSnackbar('Falha ao inserir cliente!', { 
        variant: 'error'
      })
    });
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
      <div className={styles.draw_box}>
        <div className={styles.main_column}>
          <h1 className={styles.main_title}>Adicionar cliente</h1>
          <div className={styles.main_row}>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Nome do cliente</label>
              <input
                required
                className={styles.input_box_1}
                placeholder="Escreva o nome do cliente"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
              <small className={styles.helper_text}>ex: ABC Company</small>
            </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Keyword</label>
              <input
                className={styles.input_box_1}
                placeholder="Escreva a chave do cliente"
                value={formData.key}
                onChange={(e) => setFormData({ ...formData, key: e.target.value })}
              />
              <small className={styles.helper_text}>ex: ABC</small>
            </div>
          </div>
          <div className={styles.main_row}>
          <div className={styles.main_row_item}>
            <label className={styles.field_title}>Cliente desde</label>
            <div className={styles.shadow_div}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              required={true}
              maxDate={dayjs()}
              value={formData.start}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, start: newValue })}
              />
            </LocalizationProvider>
            </div>
          </div>
            <div className={styles.main_row_item}>
              <label className={styles.field_title}>Logo do cliente</label>
              <Dropzone
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              canCancel={true}
              inputContent="Envie a imagem"
              accept="image/*"
              styles={{
                dropzone: { width: 362.594, height: 56, overflow: "hidden", minHeight: 0 },
                inputLabel: { width: 362.594, height: "100%", color: "#979797", fontFamily:"Inter" },
                preview: { width: "95%", height: "100%", minHeight: 0, padding: "0px 0px 0px 0px" },
                dropzoneActive: { borderColor: 'green' },
                previewImage: { objectFit: "cover", width: 68.8625, height: 30.5, margin: "auto auto auto auto"},
              }}
            />


            </div>
          </div>
          
          <div className={styles.main_row_item_2}>
              <label className={styles.field_title}>Escopo do cliente</label>
              <textarea
                className={styles.input_box_2}
                placeholder="Descreva o escopo do cliente"
                value={formData.escope}
                onChange={(e) => setFormData({ ...formData, escope: e.target.value })}
              />
          </div>

          <div className={styles.main_row}>
            <button className={styles.cancel_button} onClick={() => {
                cleanData();
                onClose();
              }}
            >
              Cancelar
            </button>
            <button
              disabled={!formData.name || !formData.escope || !formData.key || !logoUpload ? "disabled" : ""}
              className={styles.send_button}
              onClick={() => {
                handleSubmit();
              }}
            >
              Adicionar
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}